// Brand-wide constants

export const BRAND = {
  name: "Ace Sublimasi Nusantara",
  short: "Ace Sublimasi",
  tagline: "Custom apparel sublimasi premium dari Wonosobo untuk Indonesia.",
  description:
    "Ace Sublimasi Nusantara adalah produsen jersey futsal custom, jaket anime, haori Jepang, racing apparel, dan streetwear sublimasi. Bebas desain, produksi cepat, kualitas premium.",
  whatsapp: "628214388140", // 08214388140
  whatsappDisplay: "0821-4388-140",
  email: "aceindoprint4@gmail.com",
  ig: "acesportswear01",
  tiktok: "acesportswear02",
  address: {
    line1: "Perumahan Bumi Dieng Indah B3 No.15",
    line2: "RW 4, Andongsili, Mojotengah",
    city: "Wonosobo",
    province: "Jawa Tengah",
    postal: "56351",
  },
};

export const buildWhatsAppLink = (message = "") => {
  const text = encodeURIComponent(
    message ||
      "Halo Admin Ace Sublimasi Nusantara, saya ingin tanya soal custom apparel."
  );
  return `https://wa.me/${BRAND.whatsapp}?text=${text}`;
};

export const NAV_LINKS = [
  { to: "/", label: "Beranda" },
  { to: "/shop", label: "Shop" },
  { to: "/custom", label: "Custom Order" },
  { to: "/blog", label: "Blog" },
  { to: "/tentang", label: "Tentang" },
  { to: "/kontak", label: "Kontak" },
];

export const FORMAT_IDR = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(n);
